import waikatoRegionalCouncilLogo from '../assets/waikato-regional-council-logo.png'
import otagoRegionalCouncilLogo from '../assets/otago-regional-council-logo.png'
import aucklandCouncilLogo from '../assets/auckland-council-logo.png'
import greaterWellingtonCouncilLogo from '../assets/greater-wellington-council-logo.png'
import marlboroughDistrictCouncilLogo from '../assets/marlborough-district-council-logo.png'
import { ContentImageProps } from '@msaf/core-react'

export interface CouncilContact {
  councilName: string
  link: string
  additionalResources: Array<{ link: string; label: string }>
  image: ContentImageProps
}

export const COUNCIL_CONTACT_DATA: Array<CouncilContact> = [
  {
    councilName: 'Auckland Council',
    link: 'https://www.aucklandcouncil.govt.nz/about-auckland-council/Pages/home.aspx',
    additionalResources: [
      {
        label: 'Groundwater Levels across Auckland Region',
        link: 'https://environmentauckland.org.nz/Data/Map/Parameter/GW%20Level/Statistic/LASTRECORD/Interval/Latest',
      },
      {
        label: 'State of the Environment Auckland',
        link: 'https://knowledgeauckland.org.nz/search/?query=state+of+the+environment',
      },
      {
        label: 'Borehole Database Queries',
        link: 'https://environmentauckland.org.nz/Data/Dashboard/315',
      },
    ],
    image: { src: aucklandCouncilLogo, altText: 'Auckland Council', linkPath: 'https://www.aucklandcouncil.govt.nz' },
  },
  {
    councilName: 'Greater Wellington Regional Council',
    link: 'https://www.gw.govt.nz/your-council/contact-us/',
    additionalResources: [
      {
        label: 'Privacy statement',
        link: 'https://www.gw.govt.nz/your-council/legal/privacy-statement/',
      },
      {
        label: 'Contact us via email',
        link: 'mailto:notifications@gw.govt.nz',
      },
      {
        label: 'Environmental data and information',
        link: 'https://www.gw.govt.nz/environment/environmental-data-and-information/',
      },
      {
        label: 'Water takes and bores',
        link: 'https://www.gw.govt.nz/your-region/resource-consents/water-takes-and-bores/',
      },
    ],
    image: {
      src: greaterWellingtonCouncilLogo,
      altText: 'Greater Wellington Regional Council',
      linkPath: 'https://www.gw.govt.nz/',
    },
  },
  {
    councilName: 'Marlborough District Council',
    link: 'https://www.marlborough.govt.nz/contact-us',
    additionalResources: [
      {
        label: 'Privacy statement',
        link: 'https://www.marlborough.govt.nz/privacy-statement',
      },

      {
        label: 'Terms and conditions of use',
        link: 'https://www.marlborough.govt.nz/terms-and-conditions-of-use',
      },
      {
        label: 'Groundwater around the Marlborough region',
        link: 'https://www.marlborough.govt.nz/environment/groundwater',
      },
    ],
    image: {
      src: marlboroughDistrictCouncilLogo,
      altText: 'Marlborough District Council',
      linkPath: 'https://www.marlborough.govt.nz/',
    },
  },
  {
    councilName: 'Otago Regional Council',
    link: 'https://www.orc.govt.nz/contact-us',
    additionalResources: [
      {
        label: 'Contact us via email',
        link: 'mailto:compliance@orc.govt.nz',
      },
      {
        label: 'Groundwater around the Otago region',
        link: 'https://www.orc.govt.nz/managing-our-environment/water/groundwater',
      },
      {
        label: 'Report an error or request changes to a record',
        link: 'mailto:compliance@orc.govt.nz',
      },
      {
        label: 'Groundwater Levels across Otago Region',
        link: 'https://envdata.orc.govt.nz/AQWebPortal/Data/Dashboard/802',
      },
    ],
    image: {
      src: otagoRegionalCouncilLogo,
      altText: 'Otago Regional Council',
      linkPath: 'https://www.orc.govt.nz/',
    },
  },
  {
    councilName: 'Waikato Regional Council',
    link: 'https://www.waikatoregion.govt.nz/council/contact-us/',
    additionalResources: [
      {
        label: 'Request detailed groundwater data from WRC',
        link: 'http://waikatoregion.govt.nz/request',
      },
      {
        label: 'Groundwater levels on Envirohub',
        link: 'https://www.waikatoregion.govt.nz/environment/envirohub/environmental-maps-and-data?dt=Groundwater+Level',
      },
      {
        label: 'Groundwater around the Waikato region',
        link: 'https://www.waikatoregion.govt.nz/environment/water/groundwater/groundwater-around-the-region/',
      },
    ],
    image: {
      src: waikatoRegionalCouncilLogo,
      altText: 'Waikato Regional Council',
      linkPath: 'https://www.waikatoregion.govt.nz/',
    },
  },
]
